import './index.css';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Footer from './pages/footer';
import Home from './pages/home';
import NavBar from './pages/navbar';
import Skills from './pages/skills';
import Contact from './pages/contact';
import About from './pages/about';
import Projects from './pages/projects';

function App() {

  let Logos = [
    {logo:<ion-icon name="logo-github"></ion-icon>, userName:"GitHub", link:"https://github.com/Tonny2wo6ix5ive"},
    {logo:<ion-icon name="logo-twitter"></ion-icon>, userName:"Twitter", link:"https://twitter.com/Tonny2wo6ix5ive"},
    {logo:<ion-icon name="logo-instagram"></ion-icon>, userName:"Instagram", link:"https://www.instagram.com/tonny2wo6ix5ive"},
    {logo:<ion-icon name="logo-facebook"></ion-icon>, userName:"FaceBook", link:"https://web.facebook.com/tonny.makondesa"},
    {logo:<ion-icon name="logo-linkedin"></ion-icon>, userName:"LinkedIn", link:"https://www.linkedin.com/in/tonny-makondesa/"}
]

  let Links = [
    {name:"Home", link:"/"},
    //{name:"Skills", link:"/skills"},
    {name:"Contact", link:"/contact"},
    {name:"Projects", link:"/projects"},
    //{name:"About", link:"/about"},
]

  return (
    <Router>
      <div className="App bg-white">
      <NavBar Links={Links}/>
      <div className='min-h-screen'>
        <Switch>
        <Route exact path="/">
          <Home Logos={Logos}/>
        </Route>
        <Route path="/contact" component={Contact}>
          <Contact />
        </Route>
        <Route path='/projects' component={Projects}>
          <Projects/>
        </Route>
        <Route path="/about" component={About}>
          <About />
        </Route>
      </Switch>
      </div>
      <div>
        <Footer Links={Links}/>
      </div>
    </div>
    </Router>
  );
}

export default App;
